// require('script/util/response.js')
var $$config = require('config');

var $$model = require('model/profile');

$(function () {
    var $mod = $('.module-profile-header');

    var shareBtn = $mod.find('[node-type="share-btn"]');
    var attendBtn = $mod.find('[node-type="attend-btn-wrap"] .action');
    var letterBtn = $mod.find('[node-type="letter-btn"]');
    var logoImg = $mod.find('[node-type="profile-logo"]');

    var recommendText = $mod.find('[node-type="recommend-text"]'),
        moreBtn = $mod.find('[node-type="recommend-more-btn"]');

    var accountLink=$mod.find('.account-link')
    var accountWin=$mod.find('.account-win')
    var accountRes={}
    $$model.infoGet(window.uid,function(res){
        console.log(res,'res')
        if(!res.data){
            accountLink.css('display','none')
        }else{
            accountLink.css('display','inline-block')
            accountRes=res.data
        }
    })
    accountLink.on('click',function(){
        accountWin.toggleClass('show')
        accountLink.addClass('click')
        if(!window.focus_uid){
            accountWin.find('.account-default').show()
        }else{
            if(accountRes.type==='自媒体-个人'||accountRes.type==='家居设计师'||accountRes.type==='家居工长'){
                accountWin.find('.account-personal').find('.type-content').text(accountRes.type)
                if(accountRes.address){
                    accountWin.find('.account-personal').find('.address-content').text(accountRes.address)
                }else{
                    accountWin.find('.account-personal').find('.personal-address').css('display','none')
                }
                accountWin.find('.account-personal').show()
            }else {
                accountWin.find('.account-company').find('.type-content').text(accountRes.type)
                if(accountRes.organizationName){
                    accountWin.find('.account-company').find('.name-content').text(accountRes.organizationName)
                }else{
                    accountWin.find('.account-company').find('.company-name').css('display','none')
                }
                if(accountRes.organizationCode){
                    accountWin.find('.account-company').find('.code-content').text(accountRes.organizationCode)
                }else{
                    accountWin.find('.account-company').find('.company-code').css('display','none')
                }
                accountWin.find('.account-company').show()
            }
            
        }
    })
    accountWin.find('.account-default').on('click',function(){
        window.FCLoginHeader && FCLoginHeader.open();
    })
    $('.mask').on('click',function(e){
        console.log('test',e.target)
        if(accountWin.hasClass('show')){
            console.log('wwve')
            accountWin.removeClass('show')
            accountLink.removeClass('click')
        }
    })

    moreBtn.on('click', function () {
        if (recommendText.hasClass('limited')) {
            recommendText.removeClass('limited');
            moreBtn.html('收起<i></i>');
            moreBtn.addClass('up');
            // $mod.find('.info').css('height', 'auto')
        } else {
            recommendText.addClass('limited');
            moreBtn.html('展开<i></i>');
            moreBtn.removeClass('up');
            // $mod.find('.info').css('height', '96px')
        }
    });

    letterBtn.on('click', function () {
        if (window.uid) {
            location.href = $$config.uDomain + '#letter-contact?toAccount=' +
                window.uid;
        } else {
            location.href = $$config.loginUrl + '?ru=' + encodeURIComponent(
                $$config.uDomain + '#letter-contact?toAccount=' + window.uid);
        }
    });

    /* 关注 */
    attendBtn.on('click', function () {
        if (!window.isFollow) {
            $$model.concern(window.uid, concernCb);
        } else {
            $$model.unConcern(window.uid, unConcernCb);
        }
    });

    function concernCb(res) {
        if (res.code !== '200') {
            window.toast(res.msg);
        } else {
            window.isFollow = true;
            attendBtn.removeClass('attend-btn').addClass('attended-btn');
            attendBtn.html('已关注');
        }
    };

    function unConcernCb(res) {
        if (res.code !== '200') {
            window.toast(res.msg);
        } else {
            window.isFollow = false;
            // attendBtn.off('tap');
            attendBtn.html('关注');
            attendBtn.removeClass('attended-btn').addClass('attend-btn');
        }
    };

    // 头像加载失败显示默认
    (function () {
        var oImg = new Image();
        oImg.onerror = function () {
            logoImg.attr('src',
                'https://t1-res.focus-img.cn/sh145x145sh/misc/noavatar.png'); // 焦点默认图
        }
        oImg.src = logoImg.attr('src');
    })();
});



// WEBPACK FOOTER //
// ./src/module/profile-header/profile-header.js